import React from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useMedia } from 'use-media';

function Hamburger() {
  const isPC = useMedia({ minWidth: '1000px' });

  let navArea;
  if (isPC) {
    navArea = css`
      // nav
      .open {
        position: absolute;
        z-index: 10;
        #mask {
        background-color: #dedede;
        width: 100vw;
        height: 100vh;
        z-index: 2;
        }
        nav {
          box-shadow: 2px 3px 4px rgb(138, 137, 137);
          opacity: 1;
          top: 0;
          right: 0;
          z-index: 3;
        }
        .toggle-btn {
          span:nth-of-type(1) {
            transform: translateY(10px) rotate(-315deg);
          }

          span:nth-of-type(2) {
            opacity: 0;
          }

          span:nth-of-type(3) {
            transform: translateY(-10px) rotate(315deg);
          }
        }

      }

      .toggle-btn {
        opacity: 0;
        animation: slideInX 2s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;
        animation-delay: 0.5s;
        overflow: hidden;
        display: block;
        position: fixed;
        top: 30px;
        right: 30px;
        width: 30px;
        height: 30px;
        z-index: 3;

        @keyframes slideInX {
          0% {
            transform: translateX(-30px);
            opacity: 0;
          }

          100% {
            transform: translateX(0px);
            opacity: 1;
          }
        }

        cursor: pointer;

        span {
          position: absolute;
          display: block;
          left: 0;
          width: 30px;
          height: 2px;
          background-color: rgb(44, 38, 38);
          transition: all 0.5s;
          border-radius: 4px;
        }

        span:nth-of-type(1) {
          top: 4px;
        }

        span:nth-of-type(2) {
          top: 14px;
        }

        span:nth-of-type(3) {
          bottom: 4px;
        }
      }
  nav {
    overflow-y: auto;
    display: block;
    width: 40%;
    position: fixed;
    background-color: #ffffff;
    right: -30vw;
    bottom: 0;
    transition: all 0.5s;
    z-index: -1;
    opacity: 0;

    .inner {

      position: absolute;
      left: 50%;
      transform: translateX(-50%);

      padding: 25px;

      ul {
        text-align: center;
        list-style: none;
        margin: 0;
        margin-top: 50px;
        padding: 0;

        li {
          margin: 0;
          margin-top: 7vh;

          a {
            letter-spacing: 0.1rem;
            width: 160px;
            border-bottom: 1px solid #333;
            text-decoration: none;
            color: #333;
            display: block;
            font-size: 20px;
            padding: 10px;
            padding-bottom: 10px;
            transition-duration: 0.2s;

            &:hover {
              background-color: rgba(224, 224, 224, 0.546);
            }
          }

          //a
        }

        //li
      }

      //ul
    }

    .links {
      margin-top: 100px;
      text-align: center;
      font-size: 20px;
      color: #555555;

      a {
        color: black;
      }

      span {
        display: block;
        font-size: 22px;
        letter-spacing: 1px;
        margin-bottom: 20px;
      }
    }

    //.inner
    }

  `;
  } else {
    navArea = css`
    // nav
    .open {
      position: absolute;
      z-index: 10;
      #mask {
        background-color: #dedede;
        width: 100vw;
        height: 100vh;
        z-index: 2;
      }
      nav {
        box-shadow: 2px 3px 4px rgb(138, 137, 137);
        opacity: 1;
        top: 0;
        right: 0;
        z-index: 3;
      }
      .toggle-btn {
        span:nth-of-type(1) {
          transform: translateY(10px) rotate(-315deg);
        }

        span:nth-of-type(2) {
          opacity: 0;
        }

        span:nth-of-type(3) {
          transform: translateY(-10px) rotate(315deg);
        }
      }

    }

    .toggle-btn {
      opacity: 0;
      animation: slideInX 2s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;
      animation-delay: 0.5s;
      overflow: hidden;
      display: block;
      position: fixed;
      top: 30px;
      right: 30px;
      width: 30px;
      height: 30px;
      z-index: 3;

      @keyframes slideInX {
        0% {
          transform: translateX(-30px);
          opacity: 0;
        }

        100% {
          transform: translateX(0px);
          opacity: 1;
        }
      }

      cursor: pointer;

      span {
        position: absolute;
        display: block;
        left: 0;
        width: 30px;
        height: 2px;
        background-color: rgb(44, 38, 38);
        transition: all 0.5s;
        border-radius: 4px;
      }

      span:nth-of-type(1) {
        top: 4px;
      }

      span:nth-of-type(2) {
        top: 14px;
      }

      span:nth-of-type(3) {
        bottom: 4px;
      }
    }
    nav {
      overflow-y: auto;
      display: block;
      width: 100%;
      position: fixed;
      background-color: #ffffff;
      right: -30vw;
      bottom: 0;
      transition: all 0.5s;
      z-index: -1;
      opacity: 0;

      .inner {
        width: 70%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        padding: 25px;


        ul {

          text-align: center;
          list-style: none;
          margin: 0;
          margin-top: 80px;
          padding: 0;

          li {
            display: inline-block;
            margin-top: 7vh;
            margin-left: 7vh;
            margin-right: 7vh;

            a {
              letter-spacing: 0.1rem;
              width: 150px;
              height: auto;
              border-bottom: 1.5px solid #555;
              text-decoration: none;
              color: #555;
              font-weight: bold;
              display: block;
              font-size: 15px;
              padding: 10px;
              padding-bottom: 10px;
              transition-duration: 0.2s;

              &:hover {
                background-color: rgba(224, 224, 224, 0.546);
              }
            }

            //a
          }

          //li
        }

        //ul
      }

      .links {
        margin-top: 100px;
        text-align: center;
        font-size: 20px;
        color: #555555;

        a {
          color: black;
        }

        span {
          display: block;
          font-size: 22px;
          letter-spacing: 1px;
          margin-bottom: 20px;
        }
      }

      //.inner
    }

  `;
  }



  return (
    <div css={navArea}>

      <div id='navArea'>
        <nav>
          <div className="inner">
            <ul>
              <li><a target="_blank" href="/explain">ルール説明</a></li>
              <li><a target="_blank" href="/itemExplain">アイテム説明</a></li>
              <li><a target="_blank" href="https://honeycombgrammar.web.app/">登録されている英文</a></li>
              <li><a target="_blank" href="https://honeycombgrammar.web.app/quiz">ハニカムクイズ</a></li>
              {isPC ? (


                <li><a target="_blank" href="/teacher">先生用ページ</a></li>) : (
                <></>
              )
              }

              <li><a target="_blank" href="https://forms.gle/5UYSawi7rW1Bhmcr5">アンケート</a></li>
            </ul>
          </div>

        </nav>


        <div className="toggle-btn" onClick={addClass}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div id="mask" onClick={maskClick}></div>
      </div>
    </div>
  )
}

function addClass() {
  const nav = document.querySelector("#navArea");
  nav.classList.toggle("open");
}

function maskClick() {
  const nav = document.querySelector("#navArea");
  nav.classList.toggle("open");
}


export default Hamburger
